<template>
    <div :class="viewClass">
        <keep-alive>
            <router-view class="view" v-if="$route.meta && $route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view class="view" v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
        <app-head :backVisible="backVisible" v-if="headVisible"></app-head>
        <app-foot v-if="footVisible"></app-foot>
        <app-tool v-if="!isToolDisabled"></app-tool>
        <a href="http://www.fytvapp.com/mobile/" class="download scaleE" v-if="!isDownVisible">
            点此安装福音TV App<br>访问FYTV.NET下载安装观看更多主内视频
        </a>
        <app-share></app-share>
        <welcome :disable="false" v-if="welcomeVisible"></welcome>
    </div>
</template>

<script>
import AppFoot from './components/AppFoot.vue'
import AppHead from './components/AppHead.vue'
import AppShare from './components/AppShare.vue'
import AppTool from './components/AppTool.vue'
import Welcome from './welcome/index.vue'

export default {
    components: {
        AppHead,
        AppFoot,
        AppTool,
        AppShare,
        Welcome
    },
    data() {
        return {
            homeRoute: '',
            welcomeVisible: !!window.ad,
        }
    },
    computed: {
        isLives() {
            return this.$route.path.indexOf('/lives') >= 0
        },
        headVisible() {
            return !this.$service.common.noHead
        },
        backVisible() {
            return !this.footVisible && (this.homeRoute != this.$route.name || !this.isHome)
        },
        footVisible() {
            return !window.inApp && window.isM
        },
        viewClass() {
            return ['app' + (this.headVisible ? 1 : 0) + (this.footVisible ? 1 : 0), this.isLives ? 'live-page' : '']
        },
        isToolDisabled() {
            return !window.isM || window.inApp || this.$route.name === 'welcome' || this.$route.name === 'pay' || this.$route.name === 'phone' || this.$route.name == 'subscribe'
        },
        isDownVisible() {
            return window.inApp || this.$route.name === 'welcome' || this.$route.name === 'pay' || this.$route.name === 'phone'
        },
        isHome() {
            return window.query.home == 1
        }
    },
    mounted() {
        setTimeout(function () {
            let event = document.createEvent('Event')
            event.initEvent('app-ready', true, true)
            document.dispatchEvent(event)
        }, 500)
        this.homeRoute = this.$route.name
        this.$service.user.initialize(this)
        window.onAd = () => {
            this.welcomeVisible = window.ad
        }
    }
}
</script>
<style lang="scss" scoped>
.download {
    position: fixed;
    left: 10px;
    right: 10px;
    bottom: $app-foot-height + 10px;
    line-height: 40px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    text-align: center;
    font-size: 16px;
}

.live-page {
    padding-top: 88px;
}
</style>



// WEBPACK FOOTER //
// App.vue?07b2740c